import { render, staticRenderFns } from "./SubmitForm2.vue?vue&type=template&id=767d7b16&scoped=true"
import script from "./SubmitForm2.vue?vue&type=script&lang=ts"
export * from "./SubmitForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d7b16",
  null
  
)

export default component.exports